import uuid from 'node-uuid';
import { head, get } from 'lodash';
import {
	UPDATE_BATCH_ID,
	UPDATE_BATCH_NAME,
	TOGGLE_BATCH,
	INITIALISE_BATCH,
	SET_BATCH_AUTHORISERS,
	UPDATE_BATCH_TYPE,
} from './actions';
import { RESET_APP } from '../page/actions';
import { defaultBatchName, DAILY_LIMIT_ERROR_CODE } from '../../config';
import { RESET_DAILY_LIMIT_AUTHORISATION, INIT_PAYMENTS } from '../payments/actions';
import { RESET_CHAPS_DAILY_LIMIT_AUTHORISATION } from '../chaps/resetChapsDailyLimitAuthorisation';
import ApiConstants from '../../config/apiConstants';
import {
	SUBMIT_BATCH_REVIEW_SUCCESS,
	SUBMIT_BATCH_SUCCESS,
	SUBMIT_BATCH_FAILURE,
	STORE_BATCH_BUSINESS_ERROR,
} from '../api/fasterPaymentActions';
import {
	SUBMIT_CHAPS_BATCH_SUCCESS,
	SUBMIT_CHAPS_BATCH_FAILURE,
	SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS,
} from '../api/chapsActions';
import { isPaymentTRAObligate } from '../../utils/authoriserUtils';
import { getAuthorisationInfo } from '../../helpers/reducerHelper';

const initialBatch = (batch) => ({
	name: defaultBatchName,
	isBatch: false,
	id: uuid.v1(),
	approverId: undefined,
	...batch,
});
const getAuthorisationErrorCode = (state) => get(state, 'authorisation.error.code', 0);

const batch = (state = initialBatch(), action) => {
	switch (action.type) {
		case INITIALISE_BATCH:
			return initialBatch(action.batch);
		case UPDATE_BATCH_TYPE:
			return { ...state, batchType: action.batchType };
		case UPDATE_BATCH_NAME:
			return { ...state, name: action.name };
		case UPDATE_BATCH_ID:
			return { ...state, id: action.id };
		case TOGGLE_BATCH: {
			const { authorisation, ...newState } = state;
			return { ...newState, isBatch: action.isBatch };
		}
		case SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS:
		case SUBMIT_BATCH_REVIEW_SUCCESS: {
			const userId = get(action, 'meta.userId');
			const key = state.id;
			const response = action.payload.apiResponses.find((item) => item.id === key);

			const {
				authorisation,
				singleAuthoriserList,
				multiAuthoriserList,
				authorisers,
				authorisersGroup,
				isDefaultAuthorisers,
			} = getAuthorisationInfo(userId, response);

			const isTRAObligate = isPaymentTRAObligate(
				authorisation.ben_id_present,
				singleAuthoriserList,
				authorisation.status,
				userId
			);

			return {
				...state,
				authorisation,
				singleAuthoriserList,
				multiAuthoriserList,
				authorisers,
				authorisersGroup,
				name: get(state, 'name', '').trim() === '' ? defaultBatchName : state.name,
				isDefaultAuthorisers,
				isTRAObligate,
			};
		}
		case SUBMIT_CHAPS_BATCH_SUCCESS:
		case SUBMIT_BATCH_SUCCESS: {
			const confirmation = {
				...action.payload,
				authType: get(action, 'payload.verification_type', ''),
			};

			return { ...state, confirmation };
		}
		case SUBMIT_CHAPS_BATCH_FAILURE:
		case SUBMIT_BATCH_FAILURE: {
			const { payload } = action;
			const responseCode = payload.status;
			const confirmation = {
				responseCode,
				...payload.response,
				authType: get(action, 'payload.verification_type', ''),
			};

			return { ...state, confirmation };
		}
		case STORE_BATCH_BUSINESS_ERROR: {
			const confirmation = {
				status: ApiConstants.decline,
				error: action.payload,
			};

			return { ...state, confirmation };
		}
		case INIT_PAYMENTS: {
			if (action.payments.length > 1) {
				const firstPayment = head(action.payments);

				return {
					name: firstPayment.batchName,
					isBatch: true,
					id: firstPayment.batchId,
					context_id: firstPayment.batch_context_id,
				};
			}
			return state;
		}
		case RESET_DAILY_LIMIT_AUTHORISATION:
		case RESET_CHAPS_DAILY_LIMIT_AUTHORISATION: {
			const code = getAuthorisationErrorCode(state);
			if (code === DAILY_LIMIT_ERROR_CODE) {
				const { authorisation, ...newState } = state;
				return newState;
			}
			return state;
		}
		case RESET_APP: {
			return initialBatch();
		}

		case SET_BATCH_AUTHORISERS:
			return { ...state, authorisers: action.authorisers };

		default:
			return state;
	}
};

export default batch;
